import { useQuery } from "@tanstack/react-query";
import $api from "~@/api";
import { useAuth } from "~@/hoc/withAuthenticationRequired";

export const fetchParentsPlayers = async (token: string) => {
  const { data } = await $api.parents.getParentsPlayers(token);
  return data;
};

const useParentsPlayersQuery = () => {
  const { isAuthenticated, token } = useAuth();

  return useQuery({
    queryKey: ["parents-players"],
    queryFn: () => fetchParentsPlayers(token ?? ""),
    enabled: isAuthenticated && typeof token === "string",
  });
};

export default useParentsPlayersQuery;
